export default [
  {
    title: 'guideTitle9',
    text: {
      color: '#000000',
      content: 'guideText9_1',
      isContinued: true,
    },
    combinations: [
      { color: '#E9FF66', content: 'guideText9_3bet_tight_reactions_1', sideContent: [] },
      { color: '#E9FF66', content: 'guideText9_3bet_tight_reactions_2', sideContent: [] },
      { color: '#E9FF66', content: 'guideText9_3bet_tight_reactions_3', sideContent: [] },
      { color: '#E9FF66', content: 'guideText9_3bet_tight_reactions_4', sideContent: [] },
      { color: '#E9FF66', content: 'guideText9_3bet_tight_reactions_5', sideContent: [] },
      { color: '#E9FF66', content: 'guideText9_3bet_tight_reactions_6', sideContent: [] },
      { color: '#E9FF66', content: 'guideText9_3bet_tight_reactions_7', sideContent: [] },
      { color: '#E9FF66', content: 'guideText9_3bet_tight_reactions_8', sideContent: [] },
    ],
  },
  {
    text: {
      color: '#000000',
      content: 'guideText9_2',
      isNext: true,
      conclusion: 'guideText9_3',
    },
    combinations: [
      // { content: 'guideText9_squeeze_tight_reactions_1' },
      { content: 'guideText9_squeeze_tight_reactions_2' },
      { content: 'guideText9_squeeze_tight_reactions_3' },
      { content: 'guideText9_squeeze_tight_reactions_4' },
      { content: 'guideText9_squeeze_tight_reactions_5' },
      { content: 'guideText9_squeeze_tight_reactions_6' },
      { content: 'guideText9_squeeze_tight_reactions_7' },
    ],
  },
  {
    title: 'guideTitle10',
    text: {
      color: '#000000',
      content: 'guideText10_1',
    },
    combinations: [],
  },
];
